import React from 'react'

import { CellsWithSpacer } from './CellsWithSpacer'

export type PlanTableType = 'neutral' | 'thatch'

interface SectionProps extends Omit<React.HTMLAttributes<HTMLTableSectionElement>, 'className'> {
  children: React.ReactNode;
  header: React.ReactNode;
  plansCount?: number;
  type?: PlanTableType
}

export function Section ({ children, header, plansCount = 1, type = 'neutral', ...props }: SectionProps) {
  const textColor = type === 'thatch' ? 'text-thatch-600' : 'text-gray-800'
  const bgColor = type === 'thatch' ? 'bg-thatch-50' : 'bg-gray-100'
  const borderColor = type === 'thatch' ? 'border-thatch-200' : 'border-gray-200'

  return (
    <tbody {...props} className='before:h-6 before:block first-of-type:before:content-none'>
      <tr>
        <th
          className={`w-36 sticky left-0 border-b border-r ${borderColor} ${bgColor} font-semibold text-left ${textColor} p-4`}
          scope='rowgroup'
          role='rowheader'
        >
          {header}
        </th>
        <CellsWithSpacer>
          {Array.from({ length: plansCount }).map((_, index) => (
            <td
              className={`border-b ${borderColor} ${bgColor} p-4`}
              key={index}
            />
          ))}
        </CellsWithSpacer>
      </tr>
      {children}
    </tbody>
  )
}

Section.displayName = 'PlanTable.Section'
